module.exports = __webpack_public_path__ + "img/bottom_erweima.191ed5ec.png";